import { getEnvRequired } from '../../shared/utilities/env';

import { DossierId } from '../dossier/types';
import { ApiClient } from '../shared/api/client';

import { serializeDissatisfactionCategoriesFromAPI } from './serializers';

import { DissatisfactionCategoriesAPIResponse } from './types';

const AGENCY_INSIGHTS_URL = getEnvRequired('AGENCY_INSIGHTS_URL');

const apiClient = new ApiClient(false);

export async function getDissatisfactionCategories(dossierId: DossierId) {
    const url = `${AGENCY_INSIGHTS_URL}/customer-satisfaction/post-trip-survey/request-categories-scores/${dossierId}`;
    const response = await apiClient.get<DissatisfactionCategoriesAPIResponse>(url);
    return serializeDissatisfactionCategoriesFromAPI(response);
}
